/**
 * "Settings" — Dashboard section (ADR-0074).
 * A hub over the Settings pages: API keys, widget origins, BYOK, federation,
 * rate limits, spend caps, billing, discounts.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_SETTINGS_PAGE: DocPageContent = {
  slug: 'dashboard/settings',
  titleKey: 'docs.dashboard.settings.title',
  descriptionKey: 'docs.dashboard.settings.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.settings.lead' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.settings.item.keys',
        'docs.dashboard.settings.item.origins',
        'docs.dashboard.settings.item.byok',
        'docs.dashboard.settings.item.federation',
        'docs.dashboard.settings.item.ratelimits',
        'docs.dashboard.settings.item.spendcaps',
        'docs.dashboard.settings.item.billing',
        'docs.dashboard.settings.item.discounts',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.dashboard.settings.note.title',
      textKey: 'docs.dashboard.settings.note.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.settings.next.identity.title',
          textKey: 'docs.dashboard.settings.next.identity.text',
          to: { docSlug: 'identity' },
        },
        {
          titleKey: 'docs.dashboard.settings.next.reliability.title',
          textKey: 'docs.dashboard.settings.next.reliability.text',
          to: { docSlug: 'reliability' },
        },
      ],
    },
  ],
};
